import { SET_QUERY_CACHE, FETCH_QUERY_PROJECT_NPS, FETCH_QUERY_DRILLDOWN, } from 'src/store/types';
import md5 from 'md5';
import Query from 'src/api/query';
import Vue from 'vue';
const state = {
    project_nps: {},
    drilldown: {},
    run_query: {},
    get_aggregations: {},
    segmentation: {}
};
// const makeCacheKey = (values: any[]) => md5(values.map(v=>JSON.stringify(v)).join())
const isInCache = (state, cacheId, key) => state[cacheId][key] !== undefined;
const mutations = {
    [SET_QUERY_CACHE](state, { cacheId, key, payload }) {
        Vue.set(state[cacheId], key, payload);
    }
};
const actions = {
    async [FETCH_QUERY_DRILLDOWN]({ commit, state, getters }, { projectId, analysisId, query, dataType, returnDocuments }) {
        const key = md5(`${projectId}-${analysisId}-${JSON.stringify(query)}-${dataType}-${returnDocuments}`);
        if (isInCache(state, 'drilldown', key))
            return key;
        try {
            const result = await Query.drilldown(projectId, analysisId, query, dataType, returnDocuments, getters.savedQueries);
            commit(SET_QUERY_CACHE, { cacheId: 'drilldown', key: key, payload: result });
            return key;
        }
        catch (error) {
            // what to do if query fails?
            return null;
        }
    },
    async [FETCH_QUERY_PROJECT_NPS]({ commit, state, getters }, { projectId, analysisId, query }) {
        const key = md5(`${projectId}-${analysisId}-${JSON.stringify(query)}`);
        if (isInCache(state, 'project_nps', key))
            return key;
        try {
            const result = await Query.getNpsData(projectId, analysisId, query, getters.savedQueries);
            commit(SET_QUERY_CACHE, { cacheId: 'project_nps', key: key, payload: result });
            return key;
        }
        catch (error) {
            // what to do if query fails? return null?
            return null;
        }
    },
};
export default {
    state: state,
    mutations: mutations,
    actions: actions
};
